export default __webpack_public_path__ + "static/myra-f525f4cd79ec4cf4633b7b75d79eac40.jpeg";